import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '@base/component/BaseComponent';
import { BaseEntity } from '@base/entities/BaseEntities';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { SlideInOutAnimation } from '../../../animations/slideinout.animation';
import { EnumCardMode, EnumToggle } from '@core/framework/sysenums.enum';
import { ContextMenuElement } from '@base/classes/BaseClasses';
import { BottomSheetService } from '@m4u-angular/core/framework/bottom-sheet.service';

class CardState {
    IsOpened: boolean;
    Toggle: EnumToggle = EnumToggle.Out;
}



/**
 * If you want use several modes please specify Input field 'modes'
 * <m4u-card [Mode]="'simple'" [IsAllowExpandMode]="true">
 *      <simple-card> content </simple-card>
 *      <expand-card> expand content </expand-card>
 *      <edit-card> edit content </edit-card>
 * </m4u-card>
 */
@Component({
    providers: [ServiceBagServices],
    selector: 'm4u-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class M4UCardComponent extends BaseComponent<CardState> {

    @Input() Menu: ContextMenuElement[];
    @Input() Class: string;
    @Input() Title: string;
    @Input() ShowAsUsualOnMobile: boolean;
   

    @Output() OnClick: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('expandedCard') expandedCard: ElementRef;
    get ExpandedCardHeight() { return this.expandedCard?.nativeElement?.children[0]?.getBoundingClientRect()?.height; }

    constructor(A: ServiceBagService,
        private bottomSheetService: BottomSheetService) {
        super(A, "M4UCardComponent", CardState);
    }

    OnCardClick() {
        this.OnClick.emit();
    }

    // Show one icon if only one visible element
    get SingleVisibleElement(): ContextMenuElement 
    {
        let visibleMenus = this.Menu.filter(f => f.visible == true || f.visible == undefined);
        if (visibleMenus.length === 1) return visibleMenus[0];
        return undefined;
    }

    ToggleCardState() {
        this.State.IsOpened = !this.State.IsOpened;
    }

    GetFooterButtonText(): string {
        return this.State.IsOpened ? this.RC('lblMinimize') : this.RC('lblShowMore');
    }

    HasContent(content: any) {
        return content && content.childElementCount > 0;
    }

    OnShowContextMenu(event, cm) {
        event.preventDefault();
        event.stopPropagation();

        if (this.A.Screen.IsMobile() && !this.ShowAsUsualOnMobile) {
            const title = this.Title || this.RC('titleChooseOption');
            this.bottomSheetService.ShowContextMenu(title, this.Menu);
            return;
        }

        cm.show(event);
        return false;
    }
}
